module.exports = __webpack_public_path__ + "static/media/fxbj.108f18c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fxbj.png
// module id = 804
// module chunks = 0